import React from 'react'

function Campus() {
  return (
    <>
        <section className="steps-area2 p-relative fix" style={{ backgroundColor: "#000000" }} >
            <div className="animations-02">
                <img src="/assets/img/bg/an-img-10.png" alt="an-img-01" />
            </div>
            <div className="container">
                <div className="row align-items-center">
                <div className="col-lg-6 col-md-12">
                    <div className="step-box step-box2 wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s" >
                    <div className="dnumber">
                        <div className="date-box">
                            <img src="/assets/img/icon/fea-icon01.png" alt="icon" />
                        </div>
                    </div>
                    <div className="text">
                        <h2>Campus Tour</h2>
                        <p>
                        Campus on a tour designed for prospective graduate and
                        professional students. You will see how our university like,
                        facilities, studenst and life in this university. Meet our
                        graduate admissions representative to learn more about our
                        graduate programs and decide what it the best for you.
                        </p>
                    </div>
                    </div>
                </div>
                <div className="col-lg-6 col-md-12">
                    <div className="step-img2 wow fadeInLeft animated" data-animation="fadeInLeft" data-delay=".4s" >
                        <img src="/assets/img/bg/steps-img-2.png" alt="class image" />
                    </div>
                </div>
                </div>
            </div>
        </section>

        <section className="steps-area2 p-relative fix" style={{ backgroundColor: "#000000" }} >
            <div className="container">
                <div className="animations-08">
                    <img src="/assets/img/bg/an-img-20.png" alt="contact-bg-an-01" />
                </div>
                <div className="row align-items-center">
                <div className="col-lg-6 col-md-12">
                    <div className="step-img3 wow fadeInLeft animated" data-animation="fadeInLeft" data-delay=".4s" >
                        <img src="/assets/img/bg/steps-img-3.png" alt="class image" />
                    </div>
                </div>
                <div className="col-lg-6 col-md-12">
                    <div className="step-box step-box3 wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s" >
                    <div className="dnumber">
                        <div className="date-box">
                        <img src="/assets/img/icon/fea-icon03.png" alt="icon" />
                        </div>
                    </div>
                    <div className="text">
                        <h2>Powerful Alumni</h2>
                        <p>
                        Campus on a tour designed for prospective graduate and
                        professional students. You will see how our university like,
                        facilities, studenst and life in this university. Meet our
                        graduate admissions representative to learn more about our
                        graduate programs and decide what it the best for you.
                        </p>
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </section>
    </>
  )
}

export default Campus